var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{ref:"mapContainer",attrs:{"no-gutters":""}},[_c('map-component',{attrs:{"height":_vm.getHeight},on:{"go-home":_vm.handleGoHome,"map-toolbar-clear":_vm.handleUndo,"map-toolbar-undo":_vm.handleUndo,"map-created":_vm.handleMapCreated}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }